module.exports = __webpack_public_path__ + "img/plus.5539ba99.svg";